<template>
  <f7-page class="page-friend-list has-footer" @page:afterin="pageMounted" @page:afterout="pageBeforeOut">
    <f7-navbar :sliding="false">
      <f7-nav-title sliding>CHATBOT / HỘP THƯ</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:ellipsis_vertical" popover-open=".popover-menu"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="fixed-top">
      <f7-block inset class="mt-0 pt-1">
        <f7-segmented raised>
          <f7-button :active="tab_active === 'bot_list'" @click.prevent="tab_active = 'bot_list'">
            CHATBOT
          </f7-button>
          <f7-button :active="tab_active === 'friend_list'" @click.prevent="tab_active = 'friend_list'">
            HỘP THƯ
          </f7-button>
        </f7-segmented>
        <f7-row class="pt-1">
          <f7-col class="text-align-right">
            <a href="#" @click.prevent="getChatBotRooms(), intervalSecond = 10">Làm mới ({{ intervalSecond }})</a>
          </f7-col>
        </f7-row>
      </f7-block>
    </div>
    <div class="after-fixed-top">
      <template v-if="tab_active === 'friend_list'">
        <template v-if="!_.isEmpty(requests)">
          <f7-block-title class="mt-1">YÊU CẦU KẾT BẠN</f7-block-title>
          <f7-list class="mb-4">
            <f7-list-item v-for="(item, idx) in requests" :key="idx" :title="item.fullname">
              <template slot="after">
                <f7-segmented>
                  <f7-button round fill color="green" @click.prevent="acceptFriend(item.friendship_id)" text="Đồng ý" style="min-width: 80px"></f7-button>
                  <f7-button round fill color="red" @click.prevent="denyFriend(item.friendship_id)" text="Từ chối" style="min-width: 80px"></f7-button>
                </f7-segmented>
              </template>
            </f7-list-item>
          </f7-list>
        </template>
        <template v-if="!_.isEmpty(friends)">
          <f7-block-title class="mt-1">DANH SÁCH</f7-block-title>
          <f7-list class="mb-4" media-list>
            <f7-list-item v-for="(item, idx) in _.orderBy(friends, ['last_message_created_at'], ['desc'])" :key="idx" :title="item.fullname" :text="item.last_message | strip_tags" link @click="goToChat(item)">
              <span slot="after" class="text-small">{{ item.last_message_created_at | moment('DD/MM HH:mm') }}</span>
              <img src="../../assets/images/no-avatar.png" slot="media" class="friend-avatar">
            </f7-list-item>
          </f7-list>
        </template>
        <f7-block strong v-else class="text-align-center">
          Chưa có bạn nào!
        </f7-block>
      </template>
      <template v-else-if="tab_active === 'bot_list'">
        <template v-if="!_.isEmpty(bots)">
          <template v-if="!_.isEmpty(bots_auto)">
            <f7-block-title class="mt-1">BOT AUTO</f7-block-title>
            <f7-list class="mb-4" media-list>
              <f7-list-item v-for="(item, idx) in _.orderBy(bots_auto, ['fullname'], ['asc'])" :key="idx"
                            link
                            :class="{'bg-color-red-opacity': item.is_new}"
                            :title="item.fullname"
                            :text="`${connectedOrNot(item)} ${regionActiveOrNot(item)}`"
                            @click.prevent="goToBotView(item)">
                <img v-if="item.bot_type.indexOf('telegram') >= 0" src="../../assets/images/telegram.png" slot="media" class="friend-avatar">
                <img v-else src="../../assets/images/no-avatar.png" slot="media" class="friend-avatar">
              </f7-list-item>
            </f7-list>
          </template>
          <template v-if="!_.isEmpty(bots_forwarder)">
            <f7-block-title class="mt-1">BOT HỘI VIÊN</f7-block-title>
            <f7-list class="mb-4" media-list>
              <f7-list-item v-for="(item, idx) in _.orderBy(bots_forwarder, ['fullname'], ['asc'])" :key="idx"
                            link
                            :class="{'bg-color-red-opacity': item.is_new}"
                            :title="item.fullname"
                            :text="`${connectedOrNot(item)} ${regionActiveOrNot(item)}`"
                            @click.prevent="goToBotView(item)">
                <img v-if="item.bot_type.indexOf('telegram') >= 0" src="../../assets/images/telegram.png" slot="media" class="friend-avatar">
                <img v-else src="../../assets/images/no-avatar.png" slot="media" class="friend-avatar">
              </f7-list-item>
            </f7-list>
          </template>
          <template v-if="!_.isEmpty(bots_free)">
            <f7-block-title class="mt-1">BOT LẤY TIN</f7-block-title>
            <f7-list class="mb-4" media-list>
              <f7-list-item v-for="(item, idx) in _.orderBy(bots_free, ['fullname'], ['asc'])" :key="idx"
                            link
                            :class="{'bg-color-red-opacity': item.is_new}"
                            :title="item.fullname"
                            :text="`${connectedOrNot(item)} ${regionActiveOrNot(item)}`"
                            @click.prevent="goToBotView(item)">
                <img v-if="item.bot_type.indexOf('telegram') >= 0" src="../../assets/images/telegram.png" slot="media" class="friend-avatar">
                <img v-else src="../../assets/images/no-avatar.png" slot="media" class="friend-avatar">
              </f7-list-item>
            </f7-list>
          </template>
        </template>
        <f7-block strong v-else class="text-align-center">
          Chưa có chatbot nào!
        </f7-block>
        <f7-block strong inset class="alert-notice margin-bottom box-shadow">
          <p>* Bấm vào dấu <f7-icon ios="f7:ellipsis_vertical" size="20px"></f7-icon> góc phải màn hình lựa chọn bot bạn muốn tạo.</p>
          <ul>
            <li><b>Bot tự động</b> : Nhận tin nhắn số đúng cú pháp, tự lấy tin nhắn về tính tiền kết hợp cài đặt nhận số theo
                chuẩn muốn nhận.</li>
            <li><b>Bot hội viên</b> : Lấy tin nhắn về app KIỐT SỐ trong trường hợp bạn là người trong nhóm bot auto.</li>
            <li><b>Bot lấy tin</b> :Lấy tin nhắn về mục chat trong app KIỐT SỐ Sau đó bạn vô xử lý tin nhắn lấy tin về tính
                tiền.</li>
          </ul>
          <p> * Cài đặt cấu hình bot gồm thời gian - cho phép huỷ tin - tự động báo cáo.</p>
          <p> * Liên hệ với CSKH khi cần hướng dẫn sử dụng.</p>
          <p> Mỗi khách hàng được tặng sử dụng <b>3 Bot miễn phí</b>. Từ Bot thứ 4 trở đi, sẽ tính theo mức phí như sau :</p>
          <ul>
            <li>Bot tự động <b>5 credit</b> / ngày / bot</li>
            <li>Bot hội viên <b>3 credit</b> / ngày / bot</li>
            <li>Bot lấy tin <b>3 credit</b> / ngày / bot</li>
          </ul>
        </f7-block>
      </template>
    </div>


    <Footer :active="'chat'" />
    <f7-popover class="popover-menu">
      <f7-list>
        <f7-list-item link="/bot/tao-moi" popover-close
                      title="Tạo Bot auto">
          <f7-icon slot="media" f7="ant"></f7-icon>
        </f7-list-item>
        <f7-list-item link="/bot/tao-moi-ke-tin" popover-close
                      title="Tạo Bot hội viên">
          <f7-icon slot="media" f7="ant"></f7-icon>
        </f7-list-item>
        <f7-list-item link="/bot/tao-moi-nhan-tin" popover-close
                      title="Tạo Bot lấy tin">
          <f7-icon slot="media" f7="ant"></f7-icon>
        </f7-list-item>
        <f7-list-item link="/bot/config" popover-close
                      title="Cấu hình Bot">
          <f7-icon slot="media" f7="gear_alt"></f7-icon>
        </f7-list-item>
        <f7-list-item link popover-close
                      @click.prevent="openPromptAddFriend"
                      title="Thêm bạn">
          <f7-icon slot="media" f7="person_badge_plus"></f7-icon>
        </f7-list-item>
      </f7-list>
    </f7-popover>
  </f7-page>
</template>
<style scoped>
.fixed-top {
  position : fixed;
  top      : calc(var(--f7-navbar-height));
  height   : 92px;
  width    : 100%;
  left     : 0;
  z-index  : 109;
  background: linear-gradient(45deg, var(--fimobile-page-bg-2) 0%, var(--fimobile-page-bg-1) 100%);
}
.after-fixed-top{
  padding-top: 92px;
}
.text-small{
  font-size: 13px;
}
.bg-color-red-opacity{
  background: rgba(255, 0, 0, 0.15) !important;
}
</style>
<script>
import {mapState} from 'vuex';
import Footer from "@/components/Footer";

export default {
  data(){
    return {
      requests:[],
      tab_active: 'bot_list',
      intervalMessages: null,
      intervalSecond: 10
    }
  },
  components:{
    Footer
  },
  computed:{
    ...mapState(['friends', 'selected_customer', 'customers', 'user_info', 'bots']),
    bots_auto: function(){
      return this._.filter(this.bots, {bot_type: 'telegram'});
    },
    bots_free: function() {
      return this._.filter(this.bots, { bot_type: 'telegram_free_text' });
    },
    bots_forwarder: function() {
      return this._.filter(this.bots, { bot_type: 'telegram_forwarder' });
    }
  },
  methods:{
    subTitle(item){
      let text = '';
      if (!_.isEmpty(item.stat_messages.mn)){
        text += `MN : ${item.stat_messages.mn.converted}/${item.stat_messages.mn.total} | `;
      }
      if (!_.isEmpty(item.stat_messages.mt)) {
        text += `MT : ${item.stat_messages.mt.converted}/${item.stat_messages.mt.total} | `;
      }
      if (!_.isEmpty(item.stat_messages.mb)) {
        text += `MB : ${item.stat_messages.mb.converted}/${item.stat_messages.mb.total}`;
      }

      return text;
    },
    connectedOrNot(item){
      if(item.bot_type === 'telegram' && !_.isEmpty(item.chat_id)){
        return '✅';
      }else if (item.bot_type === 'telegram_forwarder'){
        return '✅';
      }else if (item.bot_type === 'telegram_free_text' && !_.isEmpty(item.chat_id)) {
        return '✅';
      }
      return '🟥';
    },
    regionActiveOrNot(item){
      let str = [];
      if (item.bot_type === 'telegram_free_text'){
        return 'Chỉ nhận tin';
      }
      if (this.user_info.server_region === 'hanoi'){
        str.push(`MB ${item.stat_messages.mb.converted}/${item.stat_messages.mb.total}`);
        return str.join(' | ');
      }
      if (item.config.allow_active_bot_mn){
        str.push(`MN ${item.stat_messages.mn.converted}/${item.stat_messages.mn.total}`);
      }
      if (item.config.allow_active_bot_mt) {
        str.push(`MT ${item.stat_messages.mt.converted}/${item.stat_messages.mt.total}`);
      }
      if (item.config.allow_active_bot_mb) {
        str.push(`MB ${item.stat_messages.mb.converted}/${item.stat_messages.mb.total}`);
      }
      return str.join(' | ');
    },
    getChatBotRooms() {
      let self = this;
      this.$store.dispatch('getChatBotRooms')
          .then((res) => {
          })
          .catch((error) => {
            this.$f7.dialog.alert(error, 'LỖI!');
          });
    },
    getFriends(){
      this.$f7.preloader.show();
      this.$store.dispatch('getFriendList')
          .then(() => {
            this.$f7.preloader.hide();
          })
          .catch((error) => {
            this.$f7.preloader.hide();
            this.$f7.dialog.alert(error, 'LỖI!');
          });
    },
    goToChat(item){
      this.$f7router.navigate(`/inbox/chat`, {
        props:{
          username    :item.username,
          fullname    :item.fullname,
          chatroom_key:item.chatroom_key
        }
      });
    },
    getFriendRequests(){
      // this.$f7.preloader.show();
      this.$store.dispatch('getFriendRequests')
          .then((data) => {
            // this.$f7.preloader.hide();
            this.requests = data;
          })
          .catch((error) => {
            // this.$f7.preloader.hide();
            this.$f7.dialog.alert(error, 'LỖI!');
          });
    },
    openPromptAddFriend(){
      const self = this;
      this.$f7.dialog.prompt('Nhập tài khoản muốn kết bạn', 'YÊU CẦU KẾT BẠN', (username) => {
        self.$f7.preloader.show();
        self.$store.dispatch('addFriend', {username:username})
            .then(() => {
              self.$f7.preloader.hide();
              self.$f7.dialog.alert('Đã gửi yêu cầu kết bạn', 'SUCCESS!');
              this.getFriendRequests();
            })
            .catch((error) => {
              self.$f7.preloader.hide();
              error = (error === 'This user is not exist') ? 'Tài khoản không có trong hệ thống' : error;
              self.$f7.dialog.alert(error, 'LỖI!');
            })
      })
    },
    acceptFriend(friendship_id){
      this.$store.dispatch('acceptFriend', {friendship_id:friendship_id})
          .then(() => {
            this.getFriends();
            this.getFriendRequests();
          })
          .catch((error) => {
            this.$f7.dialog.alert(error, 'LỖI!');
          })
    },
    denyFriend(friendship_id){
      this.$store.dispatch('denyFriend', {friendship_id:friendship_id})
          .then(() => {
            this.getFriendRequests();
          })
          .catch((error) => {
            this.$f7.dialog.alert(error, 'LỖI!');
          })
    },
    pageMounted(){
      let self = this;
      self.getFriends();
      self.getFriendRequests();
      self.getChatBotRooms();
      self.intervalMessages = setInterval(function(){
          self.intervalSecond--;
          if (self.intervalSecond === 0){
            self.getChatBotRooms();
            self.intervalSecond = 10;
          }
        }, 1000);
    },
    pageBeforeOut(){
      clearInterval(this.intervalMessages);
    },
    goToBotView(item) {
      let allow_active_bot = [],
        allow_convert_temp_messages = [],
        allow_overpoint_limitation = [];

      if (item.config.allow_active_bot_mn){
        allow_active_bot.push('mn');
      }
      if (item.config.allow_active_bot_mt) {
        allow_active_bot.push('mt');
      }
      if (item.config.allow_active_bot_mb) {
        allow_active_bot.push('mb');
      }
      if (item.config.allow_convert_temp_messages_mn){
        allow_convert_temp_messages.push('mn');
      }
      if (item.config.allow_convert_temp_messages_mt) {
        allow_convert_temp_messages.push('mt');
      }
      if (item.config.allow_convert_temp_messages_mb) {
        allow_convert_temp_messages.push('mb');
      }

      if (item.config.allow_overpoint_limitation_mn) {
        allow_overpoint_limitation.push('mn');
      }
      if (item.config.allow_overpoint_limitation_mt) {
        allow_overpoint_limitation.push('mt');
      }
      if (item.config.allow_overpoint_limitation_mb) {
        allow_overpoint_limitation.push('mb');
      }

      this.$store.state.selected_customer = this._.find(this.customers, { id: parseInt(item.customer_id) });
      this.$store.state.bots[this._.findIndex(this.$store.state.bots, {id: item.id})].is_new = 0;

      this.$f7router.navigate(`/bot/view`, {
        props: {
          customerId: item.customer_id,
          chatRoomId: item.id,
          fullname: item.fullname,
          botType: item.bot_type,
          connectCode: item.connect_code,
          forwardCode: item.room_forward_code,
          config: {
            room_id: item.id,
            region: item.config.selected_region,
            play_style: item.config.selected_play_style,
            allow_active_bot: allow_active_bot,
            allow_convert_temp_messages: allow_convert_temp_messages,
            allow_overpoint_limitation: allow_overpoint_limitation,
            allow_forward_room: item.config.allow_forward_room
          }
        }
      });
    },
  }
};
</script>
